export default __webpack_public_path__ + "static/media/addHome2.3719e30b.jpg";